import { Box, Grid, InputLabel, OutlinedInput, Paper, Tab, Tabs } from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import DefaultPreviewPdfFile from "../../../../components/default-preview-pdf-file";
import { IPreviewPublicationResponse } from "../../../../model/sdp/official-daily/response/preview-publication-response";

export interface IPreviewPublicationProps {
    previewPublicationResponse: IPreviewPublicationResponse,
};
export default function PreviewPublication({ props }: { props: IPreviewPublicationProps }) {
    const [tabIndex, setTabIndex] = useState(0);
    const handleTabChange = (event: any, newTabIndex: number) => {
        setTabIndex(newTabIndex);
    };
    return (<React.Fragment>
        <Grid container spacing={2}>
            <Grid item xs={6} md={6} lg={6}>
                <Paper
                    sx={{
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column'
                    }} elevation={3}
                >
                    <Box>
                        <Box>
                            <Tabs value={tabIndex} onChange={handleTabChange}>
                                <Tab label="Diário Oficial" />
                                <Tab label="Publicação" />
                                <Tab label="Contas Públicas" />
                            </Tabs>
                        </Box>
                    </Box>
                    <Box sx={{ pt: 2 }}>
                        {tabIndex === 0 && (
                            <Box>
                                <DefaultPreviewPdfFile props={{ file: props.previewPublicationResponse?.files?.officialDaily.file }}></DefaultPreviewPdfFile>
                            </Box>
                        )}
                        {tabIndex === 1 && (
                            <Box>
                                <DefaultPreviewPdfFile props={{ file: props.previewPublicationResponse?.files?.publication.file }}></DefaultPreviewPdfFile>
                            </Box>
                        )}
                        {tabIndex === 2 && (
                            <Box>
                                <DefaultPreviewPdfFile props={{ file: props.previewPublicationResponse?.files?.publicAccount.file }}></DefaultPreviewPdfFile>
                            </Box>
                        )}
                    </Box>
                </Paper>
            </Grid>
            <Grid item xs={6} md={6} lg={6}>
                <Paper
                    sx={{
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column'
                    }} elevation={3}
                >
                    <Grid container spacing={2}>
                    <Grid
                            item
                            lg={2}
                            sm={2}
                            xl={2}
                        >
                            <InputLabel>Ano</InputLabel>
                            <OutlinedInput
                                disabled
                                value={props.previewPublicationResponse?.yearPublication}
                                fullWidth
                            />
                        </Grid>
                        <Grid
                            item
                            lg={2}
                            sm={2}
                            xl={2}
                        >
                            <InputLabel>Nº Edição</InputLabel>
                            <OutlinedInput
                                disabled
                                value={props.previewPublicationResponse?.editionNumber}
                                fullWidth
                            />
                        </Grid>
             
                  
                        <Grid
                            item
                            lg={3}
                            sm={3}
                            xl={3}
                        >
                            <InputLabel>Data da Publicação</InputLabel>
                            <OutlinedInput
                                disabled
                                value={moment(props.previewPublicationResponse?.publicationDateOn).format("DD/MM/yyyy")}
                                fullWidth
                            />
                        </Grid>
                        <Grid
                            item
                            lg={12}
                            sm={12}
                            xl={12}
                        >
                            <InputLabel>Entidade</InputLabel>
                            <OutlinedInput
                                disabled
                                value={props.previewPublicationResponse?.client}
                                fullWidth
                            />
                        </Grid>
                        <Grid
                            item
                            lg={12}
                            sm={12}
                            xl={12}
                        >
                            <InputLabel>Categoria</InputLabel>
                            <OutlinedInput
                                disabled
                                value={props.previewPublicationResponse?.category}
                                fullWidth
                            />
                        </Grid>

                        <Grid
                            item
                            lg={12}
                            sm={12}
                            xl={12}
                        >
                            <InputLabel>Subategoria</InputLabel>
                            <OutlinedInput
                                disabled
                                value={props.previewPublicationResponse?.subcategory}
                                fullWidth
                            />
                        </Grid>

                        <Grid
                            item
                            lg={12}
                            sm={12}
                            xl={12}
                        >
                            <InputLabel>Orgão de Publicação</InputLabel>
                            <OutlinedInput
                                disabled
                                value={props.previewPublicationResponse?.publicAgency}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <InputLabel>Descrição</InputLabel>
                            <OutlinedInput
                                disabled
                                multiline
                                rows={15}
                                value={props.previewPublicationResponse?.description}
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </Grid>
    </React.Fragment>)
}